module.exports = __webpack_public_path__ + "img/LR.66b16d8e.svg";